import { ResourceType, ActionType, DatePreset } from "./types";

export const RESOURCE_TYPE_OPTIONS: { value: ResourceType; label: string }[] = [
  { value: "group", label: "Group" },
  { value: "dashboard", label: "Dashboard" },
  { value: "device", label: "Device" },
  { value: "user", label: "User" },
  { value: "subscription", label: "Subscription" },
  { value: "notification", label: "Notification" },
];

export const ACTION_TYPE_OPTIONS: { value: ActionType; label: string }[] = [
  { value: "update", label: "Update" },
  { value: "create", label: "Create" },
  { value: "delete", label: "Delete" },
  { value: "login", label: "Login" },
  { value: "logout", label: "Logout" },
  { value: "invite", label: "Invite" },
  { value: "remove", label: "Remove" },
  { value: "transfer", label: "Transfer" },
];

export const DATE_PRESET_OPTIONS: { value: DatePreset; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "thisWeek", label: "This Week" },
  { value: "thisMonth", label: "This Month" },
  { value: "lastMonth", label: "Last Month" },
  { value: "lastYear", label: "Last Year" },
  { value: "custom", label: "Custom Range" },
];

export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const DEFAULT_ITEMS_PER_PAGE = 10;
